import { ReactNode } from 'react';

import { InfoTooltip, Typography, Stack } from '@cast/design-system';

type Props = {
  title: string;
  cost?: ReactNode;
  infoTooltip?: string;
};

export const ChartTitle = ({ title, cost = '$--.--', infoTooltip }: Props) => {
  return (
    <Stack py={8} px={16}>
      <Stack direction="row" alignItems="center" gap={4}>
        <Typography variant="L10R">{title}</Typography>
        {!!infoTooltip && <InfoTooltip placement="top" title={infoTooltip} />}
      </Stack>
      <Typography variant="h6" noWrap>
        {cost}
      </Typography>
    </Stack>
  );
};
